import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Check, ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-6 bg-[#0c1220] relative overflow-hidden" data-id="element-95">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[#c9956b] opacity-[0.05] blur-[100px] rounded-full pointer-events-none" data-id="element-96" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#111827] rounded-3xl border border-[#c9956b]/30 p-8 md:p-12 shadow-2xl text-center" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-bold text-[#f5efe3] mb-2" data-id="element-99">
            Cierra tu día hoy mismo
          </h2>
          <p className="text-[#8b9bb4] mb-8" data-id="element-100">
            Acceso inmediato. Descarga al instante.
          </p>

          <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-101">
            <span className="text-2xl md:text-3xl text-[#8b9bb4]/50 line-through font-serif" data-id="element-102">
              $17
            </span>
            <span className="text-5xl md:text-6xl font-bold text-[#c9956b] font-serif" data-id="element-103">
              $6.39
            </span>
            <span className="text-[#8b9bb4] text-lg" data-id="element-104">USD</span>
          </div>
          <p className="text-sm text-[#c9956b]/80 mb-8 font-medium" data-id="element-105">
            Precio especial por tiempo limitado — 62% de descuento
          </p>

          <div className="max-w-sm mx-auto mb-8" data-id="element-106">
            <CTAButton fullWidth href="https://enfoqueycalma.com/cart/47613570351349:1" data-id="element-107">
              Quiero Apagar la Ansiedad Nocturna
            </CTAButton>
          </div>

          <div className="flex flex-col gap-2 text-sm text-[#8b9bb4] max-w-md mx-auto text-left" data-id="element-108">
            <div className="flex items-center gap-2" data-id="element-109">
              <Check className="w-4 h-4 text-[#c9956b] flex-shrink-0" data-id="element-110" />
              <span data-id="element-111">10 minutos, mismo orden, sin negociar</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-112">
              <Check className="w-4 h-4 text-[#c9956b] flex-shrink-0" data-id="element-113" />
              <span data-id="element-114">Enfoque: pendientes + culpa + cierre</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-115">
              <Check className="w-4 h-4 text-[#c9956b] flex-shrink-0" data-id="element-116" />
              <span data-id="element-117">Descarga digital inmediata (PDF)</span>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-white/5 flex items-center justify-center gap-2 text-xs text-[#8b9bb4]/60" data-id="element-118">
            <ShieldCheck className="w-4 h-4" data-id="element-119" />
            <span data-id="element-120">
              Pago seguro y encriptado. Garantía de satisfacción de 14 días.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}